import React, { useState } from 'react';
import Alert from './Alert';

export default function UserModal({ user, onCancel, onSave }) {
  const isEdit = !!user;
  const [form, setForm] = useState({
    name: user?.name || '',
    username: user?.username || '',
    role: user?.role || 'normal',
    phone: user?.phone || '',
    address: user?.address || '',
    password: '',
  });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  function update(field, value) {
    setForm((f) => ({ ...f, [field]: value }));
  }

  async function handleSubmit() {
    setError('');
    if (!form.name.trim() || !form.username.trim()) {
      setError('Name and username are required.');
      return;
    }
    if (!isEdit && !form.password.trim()) {
      setError('Password is required for new users.');
      return;
    }
    setSaving(true);
    try {
      const payload = {
        name: form.name.trim(),
        username: form.username.trim(),
        role: form.role,
        phone: form.phone.trim(),
        address: form.address.trim(),
      };
      if (!isEdit) payload.password = form.password;
      await onSave(payload);
    } catch (err) {
      setError(err?.response?.data?.error || 'Failed to save user.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div
      className="modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
    >
      <div className="modal">
        <div className="modal-header">
          <div className="modal-title">{isEdit ? 'Edit User' : 'Add User'}</div>
          <button className="btn btn-sm" onClick={onCancel}>
            <i className="ti ti-x" aria-hidden="true"></i>
          </button>
        </div>
        <div className="modal-body">
          <Alert type="danger" message={error} onClose={() => setError('')} />
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Full Name *</label>
              <input value={form.name} onChange={(e) => update('name', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Username *</label>
              <input
                value={form.username}
                onChange={(e) => update('username', e.target.value)}
                disabled={isEdit}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Role *</label>
              <select value={form.role} onChange={(e) => update('role', e.target.value)}>
                <option value="normal">Normal User (Staff)</option>
                <option value="admin">Admin User</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Phone</label>
              <input value={form.phone} onChange={(e) => update('phone', e.target.value)} />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Address</label>
            <textarea rows={2} value={form.address} onChange={(e) => update('address', e.target.value)} />
          </div>
          {!isEdit && (
            <div className="form-group">
              <label className="form-label">Password *</label>
              <input type="password" value={form.password} onChange={(e) => update('password', e.target.value)} />
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={saving}>
            <i className="ti ti-check" aria-hidden="true"></i>
            {saving ? 'Saving...' : isEdit ? 'Save changes' : 'Add user'}
          </button>
        </div>
      </div>
    </div>
  );
}
